import { Badge } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';

import { formatDate } from '~/utils/date';

import { COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR, DATE_FORMAT } from '~/constants';

import type { CollectingShippingLabel } from '~/types/delivery-agency.types';

const getDeliveryAgencyCollectingShippingLabelsColumnDefs = () => {
  const columnDefs: ColDef<CollectingShippingLabel>[] = [
    {
      field: 'shippingLabelNumber',
      headerName: '회수 운송장번호',
      width: 224,
    },
    {
      field: 'collectingShippingLabelStatus',
      headerName: '회수 운송장 상태',
      cellDataType: false,
      width: 120,
      cellRenderer: Badge,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<CollectingShippingLabel, CollectingShippingLabel['collectingShippingLabelStatus']>) => ({
        variant: 'light',
        status: true,
        color: value ? COLLECTING_SHIPPING_LABEL_STATUS_BADGE_COLOR[value.code] : undefined,
        children: value?.description || '-',
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'statusUpdatedAt',
      headerName: '상태 마지막 업데이트 일시',
      width: 180,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<CollectingShippingLabel, CollectingShippingLabel['statusUpdatedAt']>) =>
        formatDate(value, DATE_FORMAT.DATE_TIME) ?? '-',
    },
    {
      field: 'failureReason',
      headerName: '회수 실패 사유',
      minWidth: 170,
      flex: 1,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<CollectingShippingLabel, CollectingShippingLabel['failureReason']>) =>
        value?.description || '-',
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCollectingShippingLabelsColumnDefs;
